import { parseDate, YYYYMMDD } from "@/helpers/dateHelper";
import { CreateCustomerRequest } from "@/models/api/CreateCustomerRequest";
import { LoginRequest } from "@/models/api/LoginRequest";
import { Customer } from "@/models/www/store/User";
import accountService from "@/services/account.service";
import { storageService } from "@/services/storage.service";
import userService from "@/services/user.service";
import { ref } from "vue";

const loading = ref(false);
const useAccount = () => {
	const login = (userName: string, password: string, isAgent: boolean, cleanBooking : boolean) => {

		switch (isAgent) {
			case true:
				return userService.agentLogin({ userName, password } as LoginRequest);
			default:
				return userService.login({ userName, password, cleanBooking } as LoginRequest);
		}
	}

	const checkCustomerExist = (email: string) => {
		return userService.customerExist(email);
	}

	const create = (payload: any) => {
		const customer = {
			email: payload.email,
			firstName: payload.firstName,
			lastName: payload.lastName,
			password: payload.password,
			dateOfBirth: YYYYMMDD(parseDate(payload.dateOfBirth, "dd/MM/yyyy")),
		} as CreateCustomerRequest

		return userService.create(customer);
	}

	const forgotPassword = (email: string) => {
		const url = window.location.href;
		return userService.forgotPassword(email, url);
	}

	const validateResetToken = (id: string) => {
		return userService.validateResetToken(id);
	}

	const resetPassword = (token: string, password: string, passwordConfirm: string) => {
		return userService.resetPassword(token, password, passwordConfirm);
	}

	const logout = () => {
		loading.value = true;
		userService.logout()
			.finally(() => {
				storageService.clearAll();
				window.location.replace(location.pathname);
				loading.value = false;
			})
	}

	const getUser = () => {
		return accountService.getUser();
	}

	const updateCustomer = (customer: Customer) => {
		return accountService.updateCustomer(customer);
	}

	const updatePassword = (password: string, passwordConfirm: string) => {
		return new Promise((resolve, reject) => {
			if (password === passwordConfirm) {
				accountService.updatePassword(password)
					.then((resp) => resolve(resp))
					.catch(err => reject(err))
			} else {
				reject('Passwords do not match');
			}
		})
	}

	const setNewsletterSubscription = (subscribe: boolean) => {
		return accountService.updateNewsletter(subscribe);
	}

	return {
		login,
		checkCustomerExist,
		create,
		forgotPassword,
		resetPassword,
		validateResetToken,
		logout,
		getUser,
		updateCustomer,
		updatePassword,
		setNewsletterSubscription,
		loading
	}
}

export default useAccount;